export default __webpack_public_path__ + "assets/414ea0fe65617f78d8ab8b100fe321da.eot";